export default class Tabs {
	constructor() {
		document.querySelectorAll(".tabs").forEach(group => {
			group.setAttribute('data-setup', 'true');

			const tabPanel = group.querySelectorAll(".tab");
			let nodes = [Element];
			let tabList: NodeListOf<Element>;

			setupTabPanel();
			createTabList();
			selectFirstTab();

			function setupTabPanel(){
				tabPanel.forEach((tab)=>{
					let heading = tab.querySelector('h2');
					let label = tab.getAttribute('data-label');
					let string = label ? label : heading.textContent;
					console.log(string);

					string = string.trim();
					tab.setAttribute('id', string.toLowerCase().replace(/[\s\n]/, '-'));
					tab.setAttribute('data-label', string);
				});
			}

			function createTabList() {
				let ul = document.createElement('ul');
				tabPanel.forEach((tab)=>{
					let a = document.createElement('a');
					a.innerText = tab.getAttribute('data-label');
					a.setAttribute('href', '#'+tab.id );

					let li = document.createElement('li');
					li.classList.add('tabNavItem');
					li.appendChild(a);

					ul.appendChild(li);
					tab.removeAttribute('data-label');
				});
				group.querySelector('.tabNav').appendChild(ul);

				tabList = group.querySelectorAll(".tabNavItem a");
				nodes = Array.prototype.slice.call(tabList);
				tabList.forEach(tabListItem => tabListItem.addEventListener("click", changeTab));
			}

			function changeTab(event:Event) {
				event.preventDefault();
				const index = nodes.indexOf(this);

				for (let i = 0, l = tabList.length; i < l; i++) {
					let itemList = tabList[i].classList;
					let itemPane = tabPanel[i].classList;
					if (i == index) {
						itemList.add('active');
						itemPane.add('active');
					} else if (itemList.contains('active')) {
						itemList.remove('active');
						itemPane.remove('active');
					}
				}
			}

			function selectFirstTab(){
				tabList[0].dispatchEvent(new Event("click"));
			}
		});
	}
}

